bovoApp.controller('DashboardController', ['$scope', 'Analytic','Account', '$location','FileUploader','$http', 'Order', '$parse', '$interval', '$filter',
  function ($scope, Analytic, Account, $location, FileUploader, $http, Order, $parse, $interval, $filter) {
	$scope.calendarView = 'month';
	$scope.filterData = {
		customers: [],
		workers: [],
		workSteps: [],
		scheduled_time : { 
			startDate: moment($scope.viewDate).startOf('month'), 
			endDate: moment($scope.viewDate).endOf('month') 
		}
	}
	
	$scope.viewDate = moment();
	$scope.cellIsOpen = false;
	$scope.date = {};
	$scope.page = {
		allOrders: 1,
		pendingOrders: 1,
		completedOrders: 1,
		failedOrders: 1
	};
	moment.locale('en', {
		week : {
			dow : 1 // Monday is the first day of the week
		}
	});

	$scope.init = function (type) {
		if(type != 'notLoading')
		$scope.loadingWork = true;
		Analytic.dashboard($scope.filterData).success(function(data, status, headers, config) {
			$scope.loadingWork = false;
			$scope.data = data;
			$scope.data.workSteps.unshift({
				id : 0,
				name : 'Veri Oluşturuldu'
			});
		});
	};

	$scope.refreshScore = function() {
		$scope.init('notLoading')
		$scope.ordersFromFilter('','all','allOrders', '');
		$scope.ordersFromFilter('','pending','pendingOrders', '');
		$scope.ordersFromFilter('','completed','completedOrders', '');
		$scope.ordersFromFilter('','failed','failedOrders', '');
	}
	
	var intervalPromise;
	$scope.refreshMe = function() {
		intervalPromise = $interval($scope.refreshScore, 30000);
	}
	$scope.$on('$destroy',function(){
		if(intervalPromise)
			$interval.cancel(intervalPromise);   
	});

	$scope.refreshMe();

	$scope.ordersFromFilter = function (date, type, dataName, loadingName) {
		$scope[loadingName] = true;
		$scope.date[dataName] = date;
		Analytic.ordersFromFilter({ date: date, type : type }).success(function(data, status, headers, config) {
			$scope[loadingName] = false;
			var model = $parse(dataName);
			model.assign($scope, data.orders);
			setTimeout(function(){
				$scope.$apply();
			},300);
		});
	};

	$scope.showMore = function (type, dataName, loadingName) {
		$scope[loadingName] = true;
		Analytic.ordersFromFilterShowMore({ date: $scope.date[dataName], type : dataName, page: $scope.page[dataName] }).success(function(data, status, headers, config) {
			$scope[loadingName] = false;
			$scope.page[dataName] = data.page;
			var model = $parse(dataName);
			model.assign($scope, data.orders.data);
			setTimeout(function() {
				$scope.$apply();
			},300);
		});
	};

	$scope.changeDate = function() {
		$scope.cellIsOpen = false;
		$scope.filterData.scheduled_time = {
			startDate: moment($scope.viewDate).startOf('month'), 
			endDate: moment($scope.viewDate).endOf('month') 
		};
	};

	$scope.eventClicked = function(event) {
		$scope.getOrderDetails(event.id);
	};

	$scope.eventEdited = function(event) {
		alert('Edited', event);
	};

	$scope.eventTimesChanged = function(event) {
		alert('Dropped or resized', event);
	};

	$scope.toggle = function($event, field, event) {
		$event.preventDefault();
		$event.stopPropagation();
		event[field] = !event[field];
	};

	$scope.timespanClicked = function(date, cell) {
		if ($scope.calendarView === 'month') {
			if (($scope.cellIsOpen && moment(date).startOf('day').isSame(moment($scope.viewDate).startOf('day'))) || cell.events.length === 0 || !cell.inMonth) {
				$scope.cellIsOpen = false;
			} else {
				$scope.cellIsOpen = true;
				$scope.viewDate = date;
			}
		} else if ($scope.calendarView === 'year') {
			if (($scope.cellIsOpen && moment(date).startOf('month').isSame(moment($scope.viewDate).startOf('month'))) || cell.events.length === 0) {
				$scope.cellIsOpen = false;
			} else {
				$scope.cellIsOpen = true;
				$scope.viewDate = date;
			}
		}
	};

	$scope.clearFilter = function(page) {
		$scope.filterData = {
			customers: [],
			workers: [],
			workSteps: [],
			scheduled_time : { 
				startDate: moment($scope.viewDate).startOf('month'), 
				endDate: moment($scope.viewDate).endOf('month') 
			}
		}
	}

	// Date range default selection
	$scope.selectedDateRange = 'Son 7 Gün';
	$scope.chartView = 'day';
	$scope.sortColumn = 'shipments';
	$scope.reverseSort = true;
	$scope.currentPage = 1;
	$scope.itemsPerPage = 10;
	
	// Dummy data - will be replaced with API data
	$scope.summaryData = {
		totalShipments: 0,
		deliveredPercentage: 0,
		totalReturns: 0,
		totalLost: 0
	};
	
	$scope.customerData = [];
	$scope.filteredCustomers = [];
	$scope.pages = [];
	
	// Initialize dashboard
	initDashboard();
	
	function initDashboard() {
		// Date logic to set start and end dates
		var endDate = new Date();
		var startDate = new Date();
		startDate.setDate(endDate.getDate() - 7); // Last 7 days by default
		
		fetchDashboardData(formatDate(startDate), formatDate(endDate));
	}
	
	// Format date for API calls
	function formatDate(date) {
		return $filter('date')(date, 'yyyy-MM-dd');
	}
	
	// Set date range based on user selection
	$scope.setDateRange = function(range) {
		$scope.selectedDateRange = range;
		
		var endDate = new Date();
		var startDate = new Date();
		
		switch(range) {
			case 'Bugün':
				startDate = new Date();
				break;
			case 'Son 7 Gün':
				startDate.setDate(endDate.getDate() - 7);
				break;
			case 'Bu Ay':
				startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
				break;
			case 'Son 30 Gün':
				startDate.setDate(endDate.getDate() - 30);
				break;
			case 'Özel Aralık':
				// Show a date picker dialog
				// This is just a placeholder, implement actual date picker functionality
				alert('Başlangıç ve bitiş tarihlerini seçin');
				return;
		}
		
		fetchDashboardData(formatDate(startDate), formatDate(endDate));
	};
	
	// Fetch dashboard data from API
	function fetchDashboardData(startDate, endDate) {
		$http({
			method: 'GET',
			url: '/api/dashboard',
			params: {
				start_date: startDate,
				end_date: endDate
			}
		}).then(function(response) {
			// Process data
			processApiData(response.data);
		}, function(error) {
			console.error('Dashboard data fetch error:', error);
			// If API call fails, use sample data for demo
			useSampleData();
		});
	}
	
	// Process API response data
	function processApiData(data) {
		if (data && data.customers) {
			$scope.customerData = data.customers;
			
			// Calculate summary data
			calculateSummary();
			
			// Update pagination
			updatePagination();
			
			// Render charts
			renderCharts();
		} else {
			useSampleData();
		}
	}
	
	// Calculate summary metrics
	function calculateSummary() {
		var totalShipments = 0;
		var totalDelivered = 0;
		var totalReturns = 0;
		var totalLost = 0;
		
		angular.forEach($scope.customerData, function(customer) {
			totalShipments += customer.shipments;
			totalDelivered += customer.delivered;
			totalReturns += customer.returns;
			totalLost += customer.lost;
		});
		
		$scope.summaryData = {
			totalShipments: totalShipments,
			deliveredPercentage: totalShipments > 0 ? (totalDelivered / totalShipments) * 100 : 0,
			totalReturns: totalReturns,
			totalLost: totalLost
		};
	}
	
	// Update pagination based on filtered results
	function updatePagination() {
		$scope.filteredCustomers = $scope.customerData;
		$scope.totalItems = $scope.filteredCustomers.length;
		$scope.totalPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);
		
		$scope.pages = [];
		for (var i = 1; i <= $scope.totalPages; i++) {
			$scope.pages.push(i);
		}
		
		// Reset to first page when filter changes
		$scope.currentPage = 1;
	}
	
	// Set current page
	$scope.setPage = function(page) {
		if (page < 1 || page > $scope.totalPages) {
			return;
		}
		$scope.currentPage = page;
	};
	
	// Sort table by column
	$scope.sortBy = function(column) {
		if ($scope.sortColumn === column) {
			$scope.reverseSort = !$scope.reverseSort;
		} else {
			$scope.sortColumn = column;
			$scope.reverseSort = true;
		}
	};
	
	// Set chart view (day, week, month)
	$scope.setChartView = function(view) {
		$scope.chartView = view;
		renderDailyShipmentsChart();
	};
	
	// Refresh dashboard data
	$scope.refreshDashboard = function() {
		initDashboard();
	};
	
	// View customer details
	$scope.viewCustomerDetails = function(customerId) {
		window.location.href = '/orders?customer=' + customerId;
	};
	
	// Render all charts
	function renderCharts() {
		renderDeliveryStatusChart();
		renderCustomerShipmentsChart();
		renderDailyShipmentsChart();
		renderAverageWeightChart();
		renderSummaryCharts();
	}
	
	// Render delivery status pie chart
	function renderDeliveryStatusChart() {
		var ctx = document.getElementById('delivery-status-chart').getContext('2d');
		
		var delivered = 0;
		var returned = 0;
		var lost = 0;
		var open = 0;
		
		angular.forEach($scope.customerData, function(customer) {
			delivered += customer.delivered;
			returned += customer.returns;
			lost += customer.lost;
			open += customer.open;
		});
		
		new Chart(ctx, {
			type: 'pie',
			data: {
				labels: ['Teslim Edilen', 'İade Edilen', 'Kayıp', 'Açık Gönderi'],
				datasets: [{
					data: [delivered, returned, lost, open],
					backgroundColor: [
						'#36a2eb',  // Blue
						'#ffcd56',  // Yellow
						'#ff6384',  // Red
						'#4bc0c0'   // Teal
					]
				}]
			},
			options: {
				responsive: true,
				legend: {
					position: 'right'
				},
				title: {
					display: true,
					text: 'Teslimat Durumu Dağılımı'
				}
			}
		});
	}
	
	// Render customer shipments bar chart
	function renderCustomerShipmentsChart() {
		var ctx = document.getElementById('customer-shipments-chart').getContext('2d');
		
		// Take top 10 customers by shipment volume
		var topCustomers = $scope.customerData.slice(0);
		topCustomers.sort(function(a, b) {
			return b.shipments - a.shipments;
		});
		topCustomers = topCustomers.slice(0, 10);
		
		var customerNames = [];
		var shipmentCounts = [];
		
		angular.forEach(topCustomers, function(customer) {
			customerNames.push(customer.customer);
			shipmentCounts.push(customer.shipments);
		});
		
		new Chart(ctx, {
			type: 'horizontalBar',
			data: {
				labels: customerNames,
				datasets: [{
					label: 'Gönderi Sayısı',
					data: shipmentCounts,
					backgroundColor: '#36a2eb'
				}]
			},
			options: {
				responsive: true,
				legend: {
					display: false
				},
				title: {
					display: true,
					text: 'En Çok Gönderi Yapan Müşteriler'
				},
				scales: {
					xAxes: [{
						ticks: {
							beginAtZero: true
						}
					}]
				}
			}
		});
	}
	
	// Render daily shipments line chart
	function renderDailyShipmentsChart() {
		var ctx = document.getElementById('daily-shipments-chart').getContext('2d');
		
		// This would normally come from API, using mock data for now
		var dateLabels = [];
		var shipmentData = [];
		var deliveredData = [];
		
		// Generate sample data for last 30 days
		var endDate = new Date();
		var currentDate = new Date();
		currentDate.setDate(endDate.getDate() - 30);
		
		while (currentDate <= endDate) {
			dateLabels.push($filter('date')(currentDate, 'dd/MM'));
			shipmentData.push(Math.floor(Math.random() * 100) + 20);
			deliveredData.push(Math.floor(Math.random() * 80) + 10);
			
			currentDate.setDate(currentDate.getDate() + 1);
		}
		
		// Adjust data based on view (day, week, month)
		if ($scope.chartView !== 'day') {
			var groupedLabels = [];
			var groupedShipments = [];
			var groupedDelivered = [];
			
			var groupSize = $scope.chartView === 'week' ? 7 : 30;
			
			for (var i = 0; i < dateLabels.length; i += groupSize) {
				var endIndex = Math.min(i + groupSize, dateLabels.length);
				var shipmentSum = 0;
				var deliveredSum = 0;
				
				for (var j = i; j < endIndex; j++) {
					shipmentSum += shipmentData[j];
					deliveredSum += deliveredData[j];
				}
				
				var label = dateLabels[i] + ' - ' + dateLabels[Math.min(i + groupSize - 1, dateLabels.length - 1)];
				groupedLabels.push(label);
				groupedShipments.push(shipmentSum);
				groupedDelivered.push(deliveredSum);
			}
			
			dateLabels = groupedLabels;
			shipmentData = groupedShipments;
			deliveredData = groupedDelivered;
		}
		
		new Chart(ctx, {
			type: 'line',
			data: {
				labels: dateLabels,
				datasets: [{
					label: 'Toplam Gönderi',
					data: shipmentData,
					borderColor: '#36a2eb',
					backgroundColor: 'rgba(54, 162, 235, 0.1)',
					borderWidth: 2,
					fill: true
				}, {
					label: 'Teslim Edilen',
					data: deliveredData,
					borderColor: '#4bc0c0',
					backgroundColor: 'rgba(75, 192, 192, 0.1)',
					borderWidth: 2,
					fill: true
				}]
			},
			options: {
				responsive: true,
				title: {
					display: true,
					text: 'Gönderi Trendi'
				},
				tooltips: {
					mode: 'index',
					intersect: false
				},
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true
						}
					}]
				}
			}
		});
	}
	
	// Render average weight bar chart
	function renderAverageWeightChart() {
		var ctx = document.getElementById('average-weight-chart').getContext('2d');
		
		// Take top 5 customers by average weight
		var topByWeight = $scope.customerData.slice(0);
		topByWeight.sort(function(a, b) {
			return b.avgWeight - a.avgWeight;
		});
		topByWeight = topByWeight.slice(0, 5);
		
		var customerNames = [];
		var avgWeights = [];
		
		angular.forEach(topByWeight, function(customer) {
			customerNames.push(customer.customer);
			avgWeights.push(customer.avgWeight);
		});
		
		new Chart(ctx, {
			type: 'bar',
			data: {
				labels: customerNames,
				datasets: [{
					label: 'Ortalama Desi',
					data: avgWeights,
					backgroundColor: '#ff9f40'
				}]
			},
			options: {
				responsive: true,
				legend: {
					display: false
				},
				title: {
					display: true,
					text: 'En Yüksek Ortalama Desi'
				},
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true
						}
					}]
				}
			}
		});
	}
	
	// Render small charts for summary cards
	function renderSummaryCharts() {
		// Total shipments sparkline
		var totalCtx = document.getElementById('total-shipments-chart').getContext('2d');
		new Chart(totalCtx, {
			type: 'line',
			data: {
				labels: new Array(10).fill(''),
				datasets: [{
					data: [65, 59, 80, 81, 56, 55, 40, 45, 70, 78],
					borderColor: 'rgba(255, 255, 255, 0.8)',
					backgroundColor: 'transparent',
					borderWidth: 2,
					pointRadius: 0
				}]
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					display: false
				},
				scales: {
					xAxes: [{
						display: false
					}],
					yAxes: [{
						display: false
					}]
				},
				elements: {
					line: {
						tension: 0.4
					}
				}
			}
		});
		
		// Delivered sparkline
		var deliveredCtx = document.getElementById('delivered-chart').getContext('2d');
		new Chart(deliveredCtx, {
			type: 'line',
			data: {
				labels: new Array(10).fill(''),
				datasets: [{
					data: [70, 72, 68, 75, 81, 80, 85, 88, 87, 90],
					borderColor: 'rgba(255, 255, 255, 0.8)',
					backgroundColor: 'transparent',
					borderWidth: 2,
					pointRadius: 0
				}]
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					display: false
				},
				scales: {
					xAxes: [{
						display: false
					}],
					yAxes: [{
						display: false
					}]
				},
				elements: {
					line: {
						tension: 0.4
					}
				}
			}
		});
		
		// Returns sparkline
		var returnsCtx = document.getElementById('returns-chart').getContext('2d');
		new Chart(returnsCtx, {
			type: 'line',
			data: {
				labels: new Array(10).fill(''),
				datasets: [{
					data: [12, 15, 11, 10, 16, 14, 12, 9, 7, 5],
					borderColor: 'rgba(255, 255, 255, 0.8)',
					backgroundColor: 'transparent',
					borderWidth: 2,
					pointRadius: 0
				}]
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					display: false
				},
				scales: {
					xAxes: [{
						display: false
					}],
					yAxes: [{
						display: false
					}]
				},
				elements: {
					line: {
						tension: 0.4
					}
				}
			}
		});
		
		// Lost sparkline
		var lostCtx = document.getElementById('lost-chart').getContext('2d');
		new Chart(lostCtx, {
			type: 'line',
			data: {
				labels: new Array(10).fill(''),
				datasets: [{
					data: [3, 2, 4, 5, 2, 1, 2, 3, 2, 1],
					borderColor: 'rgba(255, 255, 255, 0.8)',
					backgroundColor: 'transparent',
					borderWidth: 2,
					pointRadius: 0
				}]
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					display: false
				},
				scales: {
					xAxes: [{
						display: false
					}],
					yAxes: [{
						display: false
					}]
				},
				elements: {
					line: {
						tension: 0.4
					}
				}
			}
		});
	}
	
	// Use sample data for demonstration
	function useSampleData() {
		$scope.customerData = [
			{id: 1, customer: 'ABC Elektronik', shipments: 256, delivered: 220, returns: 25, lost: 5, open: 6, avgWeight: 3.8},
			{id: 2, customer: 'XYZ Market', shipments: 195, delivered: 170, returns: 15, lost: 2, open: 8, avgWeight: 5.2},
			{id: 3, customer: 'Delta Tekstil', shipments: 310, delivered: 290, returns: 10, lost: 3, open: 7, avgWeight: 2.1},
			{id: 4, customer: 'Mega Mobilya', shipments: 150, delivered: 130, returns: 12, lost: 1, open: 7, avgWeight: 8.5},
			{id: 5, customer: 'Hızlı Ticaret', shipments: 230, delivered: 200, returns: 20, lost: 4, open: 6, avgWeight: 4.3},
			{id: 6, customer: 'Yıldız Teknoloji', shipments: 189, delivered: 160, returns: 18, lost: 2, open: 9, avgWeight: 3.7},
			{id: 7, customer: 'Optima Beyaz Eşya', shipments: 267, delivered: 245, returns: 15, lost: 0, open: 7, avgWeight: 9.2},
			{id: 8, customer: 'Global Moda', shipments: 178, delivered: 155, returns: 14, lost: 3, open: 6, avgWeight: 1.8},
			{id: 9, customer: 'Prizma Oyuncak', shipments: 142, delivered: 125, returns: 12, lost: 1, open: 4, avgWeight: 2.5},
			{id: 10, customer: 'Ekol Kozmetik', shipments: 205, delivered: 185, returns: 15, lost: 0, open: 5, avgWeight: 1.5},
			{id: 11, customer: 'Nova Ayakkabı', shipments: 166, delivered: 145, returns: 16, lost: 0, open: 5, avgWeight: 3.2},
			{id: 12, customer: 'Atlas Kitap', shipments: 124, delivered: 115, returns: 6, lost: 0, open: 3, avgWeight: 4.0}
		];
		
		calculateSummary();
		updatePagination();
		renderCharts();
	}
}]);
